export const priceQuotesApiUrlWithoutAPIPrefix =
  '_api/wix-quotes-web/v1/price-quotes';
export const priceQuotesApiUrl = '/_api/wix-quotes-web/v1/price-quotes';
export const chatAppId = '14517e1a-3ff0-af98-408e-2bd6953c36a2';
export const priceQuotesAppId = '55cd9036-36bb-480b-8ddc-afda3cb2eb8d';
export const defaultNS = 'invoice-view';
export const fakeSecret = 'someSecret';
export const RECURRING_INVOICES_APP_ID = '35aec784-bbec-4e6e-abcb-d3d724af52cf';
export const RECURRING_INSTANCE_ID = '53d86a6c-30d3-461b-b863-788483f3812c';
export const INVOICES_APP_DEF_ID = '13ee94c1-b635-8505-3391-97919052c16f';
export const ORDER_NUMBER_CUSTOM_FIELD_KEY = 'invoices.document.order-number';
export const STORES_ORDER_NUMBER_METADATA_KEY = 'view_order';
export const ORDER_NUMBER_PREFIX = 'Invoice for order: #';

export const EXPERIMENT_SWAP_AMBASSADOR_ARTIFACT_ID =
  'specs.invoices.SwapRecurringInvoicesArtifactId';

export const RECURRING_INVOICE_ARTIFACT_ID =
  'com.wixpress.recurring.invoices.recurring-invoices-server';
